import { env, PlatformEnv } from "./env";

const ENV_SPECIFIC_CONSTANTS: Record<
  PlatformEnv,
  {
    INVITE_EXPIRATION_DAYS: number;
    ASSET_URL_EXPIRATION_SECONDS: number;
    SUPPORT_EMAIL: string;
    WRANGO_KNOWLEDGE_BASE_URL: string;
    MAX_WORKSPACES_PER_ORG: number;
    MAX_TRAITS_PER_AUDIENCE: number;
    KOMODO_MIGRATION_CUTOFF: string;
  }
> = {
  dev: {
    INVITE_EXPIRATION_DAYS: 7,
    ASSET_URL_EXPIRATION_SECONDS: 3600,
    SUPPORT_EMAIL: "support@dev.wrango.io",
    WRANGO_KNOWLEDGE_BASE_URL: "https://www.mintlify.com",
    MAX_WORKSPACES_PER_ORG: 100,
    MAX_TRAITS_PER_AUDIENCE: 1000,
    KOMODO_MIGRATION_CUTOFF: "2026-10-08T00:00:00-04:00",
  },
  qa: {
    INVITE_EXPIRATION_DAYS: 7,
    ASSET_URL_EXPIRATION_SECONDS: 3600,
    SUPPORT_EMAIL: "support@qa.wrango.io",
    WRANGO_KNOWLEDGE_BASE_URL: "https://www.mintlify.com",
    MAX_WORKSPACES_PER_ORG: 100,
    MAX_TRAITS_PER_AUDIENCE: 2000,
    KOMODO_MIGRATION_CUTOFF: "2026-10-08T00:00:00-04:00",
  },
  staging: {
    INVITE_EXPIRATION_DAYS: 7,
    ASSET_URL_EXPIRATION_SECONDS: 3600,
    SUPPORT_EMAIL: "support@staging.wrango.io",
    WRANGO_KNOWLEDGE_BASE_URL: "https://www.mintlify.com",
    MAX_WORKSPACES_PER_ORG: 100,
    MAX_TRAITS_PER_AUDIENCE: 2000,
    KOMODO_MIGRATION_CUTOFF: "2026-10-08T00:00:00-04:00",
  },
  prod: {
    INVITE_EXPIRATION_DAYS: 7,
    ASSET_URL_EXPIRATION_SECONDS: 3600,
    SUPPORT_EMAIL: "support@wrango.io",
    WRANGO_KNOWLEDGE_BASE_URL: "https://www.mintlify.com",
    MAX_WORKSPACES_PER_ORG: 100,
    MAX_TRAITS_PER_AUDIENCE: 2000,
    KOMODO_MIGRATION_CUTOFF: "2026-10-21T17:00:00-04:00",
  },
};

export const DEFAULT_LANGUAGE = "en";
export const ONE_DAY_MS = 24 * 60 * 60 * 1000;
export const INVITE_EXPIRATION_DAYS =
  ENV_SPECIFIC_CONSTANTS[env].INVITE_EXPIRATION_DAYS;
export const ASSET_URL_EXPIRATION_SECONDS =
  ENV_SPECIFIC_CONSTANTS[env].ASSET_URL_EXPIRATION_SECONDS;
export const SUPPORT_EMAIL = ENV_SPECIFIC_CONSTANTS[env].SUPPORT_EMAIL;
export const WRANGO_KNOWLEDGE_BASE_URL =
  ENV_SPECIFIC_CONSTANTS[env].WRANGO_KNOWLEDGE_BASE_URL;
export const MAX_WORKSPACES_PER_ORG =
  ENV_SPECIFIC_CONSTANTS[env].MAX_WORKSPACES_PER_ORG;
export const MAX_TRAITS_PER_AUDIENCE =
  ENV_SPECIFIC_CONSTANTS[env].MAX_TRAITS_PER_AUDIENCE;
// GO-3393: drafts and reports created before this instant were built on the
// pre-Komodo metadata and get the one-time "We've enhanced our data" notice.
// Prod is the Komodo release; lower envs use an earlier test date so QA can
// check both sides of the cutoff.
export const KOMODO_MIGRATION_CUTOFF =
  ENV_SPECIFIC_CONSTANTS[env].KOMODO_MIGRATION_CUTOFF;

// GO-739: rate limit workspace.create per user. Not env-specific —
// the abuse pattern doesn't depend on environment.
export const MAX_WORKSPACES_CREATE_PER_HOUR_PER_USER = 10;
